import {Directive, Input, Output, ElementRef, EventEmitter} from '@angular/core';

import 'jquery-slimscroll';

@Directive({
  selector: '[baSlimScroll]'
})
export class BaSlimScroll {

  @Input() public baSlimScrollOptions:Object;

  constructor(private _elementRef:ElementRef) {
  }

  ngOnChanges(changes) {
    this._scroll();
  }

  private _scroll() {
    this._destroy();
    this._init();
  }

  private _init() {
    (<any>jQuery(this._elementRef.nativeElement)).slimScroll(this.baSlimScrollOptions);
  }

  private _destroy() {
    (<any>jQuery(this._elementRef.nativeElement)).slimScroll({ destroy: true });
  }
}



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/theme/directives/baSlimScroll/baSlimScroll.directive.ts